import { z } from "zod";

export const ExporterFunctionPayload = z.object({
  exportJobId: z.string(),
  exportContextId: z.string(),
  designSystemId: z.string(),
  workspaceId: z.string(),
  exporterId: z.string(),
});

export type ExporterFunctionPayload = z.infer<typeof ExporterFunctionPayload>;
